/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires these libraries to be loaded first
* jQuery
* Underscore.js
* moment.js
*/

var _ = {}
_.each = require('lodash.foreach')
_.indexOf = require('lodash.indexof')
_.flattenDeep = require('lodash.flattendeep')


var GroupBy = (function () {
    return function (groupFunctionIn, entityTypeIn, propertyNameIn, dataTypeIn, sortDirectionIn, formatIn) {
        /** Private Variables */
        /**The entity type that we are grouping on*/
        var entityType = entityTypeIn;
        /** The KdEntity property that we are grouping on*/
        var propertyName = propertyNameIn;
        /** The dataType that we are grouping on*/
        var dataType = dataTypeIn;
        /** The groupFunctionIn for this property
         * Valid function values are: GroupBy, Count, Sum, Avg, StdDev, Median,
         * Valid function values for any DataType are: GroupBy, Min, Max, Mode, Distinct
         * Valid function values for Number and Date DataType are: Median
         * Valid function values for Number only DataType are: Sum, Avg, StdDev
         */
        var groupFunction = groupFunctionIn;
        /**
        * Valid sort by Direction values are: asc|desc
        */
        var direction = sortDirectionIn;  //

        /**format represents how to group by a Date or Number property can be represented if GroupBy
         * a Date property groups by data ranges can have a format of 'yyyy', 'yyyy-mm', 'yyyy-mm-dd', 'mm-dd', etc.
         * a Number property groups by number ranges and can have format of '<1,1-10,11-20,21-30,>30'
         * the 1-10 is a between 1 and 10 inclusive (so includes the values 1 and 10)
         */
        var format = formatIn;
        /** Private Functions */


        var errorCheckDirection = function(directionToCheck) {
            if (_.indexOf(["asc", "desc"], directionToCheck) === -1) {
                throw directionToCheck + " is not a valid OrderBy Direction.  Valid Direction values are asc|desc";
            };
        };

        var errorCheckInitState = function () {
            if(groupFunction === "Count"){
                return true;
            }
            if (!entityType) {
                throw "The SelectItem does not have an PropertyName set";
            }
            if (!propertyName) {
                throw "The SelectItem does not have an PropertyName set";
            }


        };

        var init = function () {
            errorCheckInitState();
        };

        /** Public Variables */


        //Privileged functions, can access both public and private
        //We need functions here to do error checking and handling
        this.getGroupFunction = function () {
            return groupFunction;
        };

        this.getEntityType = function () {
            return entityType;
        };
        this.setEntityType = function (groupByEntityType) {
            if (!groupByEntityType) {
                throw "A valid SelectItem EntityType is required";
            }
            else {
                entityType = groupByEntityType;
                return entityType;
            }
        };

        this.getPropertyName = function () {
            return propertyName;
        };
        this.setPropertyName = function (groupByPropertyName) {
            if (!groupByPropertyName) {
                throw "A valid SelectItem PropertyName is required";
            }
            else {
                propertyName = groupByPropertyName;
                return propertyName;
            }
        };

        this.getDataType = function () {
            return dataType;
        };

        this.getFormat = function () {
            return format;
        };


        this.getDirection = function () {
            return direction;
        };
        this.setDirection = function (groupByDirection) {
            if (!groupByDirection) {
                throw "A valid SelectItem Direction is required";
            }
            else {
                direction = groupByDirection;
                return direction;
            }
        };



        /** Returns a struct that can be passed to the kd API as a filter (part of a FilterList)*/
        this.getGroupByValue = function () {
            var groupBy = {};
            groupBy.EntityType = entityType;
            groupBy.PropertyName = propertyName;
            groupBy.DataType = dataType;
            groupBy.GroupFunction = groupFunction;
            groupBy.Direction = direction;
            groupBy.Format = format;


            /**
            * Error handling
            */
            errorCheckInitState();

            return groupBy;
        };

        /** Init functions*/

        init();

    };
})();

var GroupByList = (function () {
    return function () {
        //Private Variables
        var groupByList = [];

        //Private Functions
        var getGroupByListValues = function () {
            var groupBys = [];
            _.each(groupByList, function (item) {
                groupBys.push(item.getGroupByValue());
            });
            return groupBys;
        }

        var removeFromList = function (groupByToRemove) {
            _.each(groupByList, function (item, index) {
                if (
                    groupByToRemove.getEntityType() === item.getEntityType()
                    && groupByToRemove.getPropertyName() === item.getPropertyName()
                    && groupByToRemove.getDataType() === item.getDataType()
                    && groupByToRemove.getGroupFunction() === item.getGroupFunction()
                    && groupByToRemove.getDirection() === item.getDirection()
                    && groupByToRemove.getFormat() === item.getFormat()

                ) {
                    groupByList.splice(index, 1); // at position index remove one item
                }
            });
            return groupByList;
        }

        var rejectGroupBy = function (groupByIn) {
            return !groupByIn; //for now just return true or false if filter is null
        }

        //Public Variables
        //None for this closure

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.addGroupBy = function (groupByIn) {
            if (rejectGroupBy(groupByIn)) return "A valid Kd SelectItem Object is required";
            else {
                groupByList.push(groupByIn);
                return groupByList;
            }
        };
        this.removeGroupBy = function (groupByIn) {
            if (rejectGroupBy(groupByIn)) return "A valid Kd SelectItem Object is required";
            else {
                removeFromList(groupByIn);
                return groupByList;
            }
        };
        this.getGroupByModel = function () {
            return groupByList;
        };
        this.getGroupByValue = function () {
            var groupByListStruct = getGroupByListValues();

            return groupByListStruct;
        };

        this.clearGroupBy = function () {
            _.each(groupByList, function (groupBy, index) {
                groupBy.clearSelected();
            });
        };

        /*patch 3.0.2 updating term from groupBy to column**/

        this.addSelectItem = function (columnIn) {
            if (rejectGroupBy(columnIn)) return "A valid Kd SelectItem Object is required";
            else {
                groupByList.push(columnIn);
                return groupByList;
            }
        };
        this.removeSelectItem = function (columnIn) {
            if (rejectGroupBy(columnIn)) return "A valid Kd SelectItem Object is required";
            else {
                removeFromList(columnIn);
                return groupByList;
            }
        };
        this.getSelectListModel = function () {
            return groupByList;
        };
        this.getSelectListValue = function () {
            var groupByListStruct = getGroupByListValues();

            return groupByListStruct;
        };

        this.clearSelectList = function () {
            _.each(groupByList, function (column, index) {
                column.clearSelected();
            });
        };

    };
})();


exports.GroupBy = GroupBy
exports.GroupByList = GroupByList



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.GroupBy.js
// module id = 203
// module chunks = 0